document.addEventListener("turbolinks:load", function() {
  if (document.querySelector('.admin')) {
    if (document.getElementById('index')) {
      console.log('laddar js för admin -> index');
    }
  }
});